import React, { useState } from "react";
import {
  AppBar,
  Box,
  Fab,
  IconButton,
  Modal,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { useInsightsChatbotConfig } from "../context";
import { InsightsAssistant } from "./InsightsAssistant";
import PeakieMobileIcon from "../../../../assets/Peakie AI Mobile Icon.png";

export const InsightsChatbotWidget: React.FC = () => {
  const { config } = useInsightsChatbotConfig();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Fab
        color="primary"
        aria-label="Open insights assistant"
        onClick={() => setOpen(true)}
        sx={{
          position: "fixed",
          right: 24,
          bottom: 24,
          zIndex: 1400,
        }}
      >
        <ChatBubbleOutlineIcon />
      </Fab>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "fixed",
            right: 16,
            bottom: 16,
            width: { xs: "calc(100% - 32px)", sm: 640, md: 720 },
            height: { xs: "calc(100% - 32px)", sm: 760, md: 840 },
            maxHeight: "calc(100% - 32px)",
            outline: "none",
          }}
        >
          <Paper
            elevation={6}
            sx={{
              height: "100%",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
            }}
          >
            <AppBar position="static" color="transparent" elevation={0}>
              <Toolbar
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  gap: 1.5,
                }}
              >
                <Box
                  component="img"
                  src={PeakieMobileIcon}
                  alt="Peakie AI"
                  sx={{ width: 32, height: 32, borderRadius: 1 }}
                />
                <Typography variant="subtitle1" fontWeight={700} sx={{ flex: 1 }}>
                  {config.title ?? "Peakie AI"}
                </Typography>
                <IconButton
                  edge="end"
                  aria-label="Close"
                  onClick={() => setOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>

            <Box sx={{ flex: 1, minHeight: 0, p: 2 }}>
              <InsightsAssistant
                buildRequest={config.buildRequest}
                initialPrompt={config.initialPrompt}
              />
            </Box>
          </Paper>
        </Box>
      </Modal>
    </>
  );
};
